module.exports = __webpack_public_path__ + "static/img/mine_order@3x.cbf6f5d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mine_order@3x.png
// module id = 17W1
// module chunks = 1